import { type FC, useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

import { envs } from '@/envs'
import { apiRequestNew } from '@/helpers/request'
import { getMs } from '@/helpers'
import { rqKeys } from '@/react-query-keys'
import { Drawer, Skeleton } from '@/components'
import type { T_NewsArticleRes } from '@/types/responses'
import { SC_Content } from './styled'


interface T_NewsArticleDrawerProps {
  articleName: string | null
  onClose: () => void
}

export const NewsArticleDrawer: FC<T_NewsArticleDrawerProps> = ({
  articleName,
  onClose,
}) => {
  const newsMediaDomain = envs.TRUSTED_API_DOMAIN

  const {
    data: articleRes,
    isPending,
  } = useQuery<T_NewsArticleRes>({
    queryKey: [ rqKeys.newsArticle, articleName ],
    queryFn: () => apiRequestNew(
      'GET',
      `/portal/article?lang=47&fields=id,time,path,name,title,description,content,video&visitor_group=1,4&path=information/news&name=${articleName}`
    ),
    enabled: !!articleName,
    staleTime: getMs('15m'),
    refetchOnWindowFocus: false,
  })

  const article = useMemo(() => {
    const data = articleRes?.[0]

    if (data?.content?.ru && newsMediaDomain) {
      return {
        ...data,
        content: {
          ...data.content,
          ru: data.content.ru.replace(
            /(src\s*=\s*["'])(\/data\/files\/[^"']+)(["'])/gi,
            `$1${newsMediaDomain}$2$3`
          ),
        },
      }
    }

    return data
  }, [ articleRes, newsMediaDomain ])


  return (
    <Drawer
      backTitle='Вернуться назад'
      onClose={onClose}
      isBackdropClosable
      isFullScreen
    >
      {isPending ? (
        <div style={{ padding: '16px' }}>
          <Skeleton count={5} />
        </div>
      ) : (
        <SC_Content
          dangerouslySetInnerHTML={{ __html: article?.content?.ru || '' }}
        />
      )}
    </Drawer>
  )
}
